import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomPreloadingStrategy } from './core/custom-preloading.strategy';


const routes: Routes = [

  {
    path: 'ab-project',
    loadChildren:() => import('./project/project.module').then(mod =>mod.ProjectModule),

  },
  // {
  //   path: 'home',
  //   loadChildren:() => import('./home/home.module').then(mod =>mod.HomeModule),
  // },
  {
    path: 'smart-search',
    loadChildren:() => import('./smart-view/smart-view.module').then(mod =>mod.SmartViewModule),

  },{
    path: 'chat-product-assistant',
    loadChildren:() => import('./chat-product-assistant/chat-product-assistant.module').then(mod =>mod.ChatProductAssistantModule),
  },
  {
    path:'',
    loadChildren:() => import('./v3-home/v3-home.module').then(mod =>mod.V3HomeModule),
    data: { preload: true,animation: true },
  },
  {
    path:'product/:department',
    loadChildren:() => import('./product-v3/product-v3.module').then(mod=>mod.ProductV3Module)
  },
  {
    path:'p/:slug_name',
    loadChildren:() => import('./product-detail/product-detail.module').then(mod =>mod.ProductDetailModule),
  },
  {
    path:'contact',
    loadChildren:() => import('./contact/contact.module').then(mod =>mod.ContactModule),
  },
  {
    path:'site-map',
    loadChildren:() => import('./site-map/site-map.module').then(mod =>mod.SiteMapModule)
  },
   {
    path:'department/:department',
    loadChildren:() => import('./department/department.module').then(mod =>mod.DepartmentModule),
  },
  {
    path:'d/:department/:categorytype',
    loadChildren:() => import('./category/category.module').then(mod =>mod.CategoryModule),
  },
  {
    path:'digital-library-of-interior-products',
    loadChildren:() => import('./digital-library-of-interior-products/digital-library-of-interior-products.module').then(mod =>mod.DigitalLibraryOfInteriorProductsModule),
  },
  {
    path: 'as-collection',
    loadChildren:() => import('./as-product-collection/as-product-collection.module').then(mod=>mod.AsProductCollectionModule)
  },
  {
    path:'budget-calc',
    loadChildren:()=> import('./budget-container/budget-container.module').then(mod=>mod.BudgetContainerModule),
    data: { preload: false }

  },
{
  path:'brand',
  loadChildren:() => import('./brand/brand.module').then(mod =>mod.BrandModule),
},{
  path:'dealer',
  loadChildren:() => import('./dealer/dealer.module').then(mod =>mod.DealerModule),
},
{
  path:'service-provider',
  loadChildren:() => import('./service-provider/service-provider.module').then(mod =>mod.ServiceProviderModule),
},
{
  path:'about',
  loadChildren:() => import('./about/about.module').then(mod =>mod.AboutModule),
},
{
  path:'terms-and-condition',
  loadChildren:()=> import('./policy/terms-and-condition/terms-and-condition.module').then(mod =>mod.TermsAndConditionModule),
},
{
  path:'login',
  loadChildren:()=> import('./login/login.module').then(mod =>mod.LoginModule)
},{
  path:'saved-ideas/:slugname',
  loadChildren:()=> import('./saved-ideas/saved-ideas.module').then(mod =>mod.SavedIdeasModule)
},{
  path:'my-list',
  loadChildren:()=> import('./my-list/my-list.module').then(mod =>mod.MyListModule)
},{
  path:'cart',
  loadChildren:()=> import('./cart/cart.module').then(mod =>mod.CartModule)
},{
  path:'store-visits',
  loadChildren:()=> import('./store-visit/store-visit.module').then(mod =>mod.StoreVisitModule)
},
{
  path:'live-offers',
  loadChildren:()=> import('./live-offers/live-offers.module').then(mod => mod.LiveOffersModule)
},
{
  path:'house-spaces',
  loadChildren:()=> import('./house-spaces/house-spaces.module').then(mod => mod.HouseSpacesModule)
},{
  path:'checkout',
  loadChildren:()=> import('./checkout/checkout.module').then(mod=>mod.CheckoutModule)
},
{
  path:'old-my-order',
  loadChildren:()=> import('./my-order/my-order.module').then(mod=>mod.MyOrderModule)
},
{
  path:'my-order',
  loadChildren:()=> import('./order/order.module').then(mod=>mod.OrderModule)
},
{
  path:'compare/:department',
  loadChildren:() => import('./product-compare/product-compare.module').then(mod=>mod.ProductCompareModule)
},
{
  path:'collection/:department',
  loadChildren:() => import('./product-collection/product-collection.module').then(mod=>mod.ProductCollectionModule)
},
{
  path:'profile',
  loadChildren:() => import('./profile/profile.module').then(mod=>mod.ProfileModule)
},
{
  path:'notifications',
  loadChildren:() => import('./more-notifications/more-notifications.module').then(mod=>mod.MoreNotificationsModule)
},
{ path: 'faq',loadChildren:() => import('./help/faq/faq.module').then(mod=>mod.FaqModule) },

{ path: 'sample-faq',loadChildren:() => import('./help/sample-faq/sample-faq.module').then(mod=>mod.SampleFaqModule) },
{ path: 'sourcing-terms',loadChildren:() => import('./policy/sourcing-terms/sourcing-terms.module').then(mod=>mod.SourcingTermsModule) },
{path:'shipping-policy',loadChildren:() => import('./policy/shipping-policy/shipping-policy.module').then(mod=>mod.ShippingPolicyModule) },
{path:'refund-policy',loadChildren:() => import('./policy/refund-policy/refund-policy.module').then(mod=>mod.RefundPolicyModule) },
{path:'privacy-policy',loadChildren:() => import('./policy/privacy-policy/privacy-policy.module').then(mod=>mod.PrivacyPolicyModule) },
{
  path:'oem',
  loadChildren:() => import('./oem-registration/oem-registration.module').then(mod=>mod.OemRegistrationModule)
},
{
  path:'cashback',
  loadChildren:()=> import('./cashback/cashback.module').then(mod=>mod.CashbackModule)
},
{
  path:'redirect-to-other-site',
  loadChildren:()=> import('./redirect-to-other-site/redirect-to-other-site.module').then(mod=>mod.RedirectToOtherSiteModule)
},
{
  path:'sample-checkout',
  loadChildren:()=> import('./sample-checkout/sample-checkout.module').then(mod=>mod.SampleCheckoutModule)
},
{
  path:'sample-order',
  loadChildren:()=> import('./sample-order/sample-order.module').then(mod=>mod.SampleOrderModule)
},
{
  path:'new-test-design',
  loadChildren:()=> import('./new-test-design/new-test-design.module').then(mod =>mod.NewTestDesignModule)
},

{
  path:'404',
  loadChildren:()=> import('./page-not-found/page-not-found.module').then(mod =>mod.PageNotFoundModule)
},
{ path: '**', redirectTo: '/404' },


];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // scrollPositionRestoration: 'disabled',
    // initialNavigation: 'enabledBlocking',
    // enableTracing: false,
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabledBlocking',
    // preloadingStrategy: PreloadAllModules,
    preloadingStrategy: CustomPreloadingStrategy,
})],

  exports: [RouterModule]
})
export class AppRoutingModule { }
